import React from 'react';
import { useNews } from '../../context/NewsContext';
import useIsMobile from '../../shared/hooks/useIsMobile';
import AllNewsMobile from './AllNews.mobile';
import AllNewsDesktop from './AllNews.desktop';

const AllNewsFeature = () => {
  const { publishedNews } = useNews();
  const isMobile = useIsMobile();

  if (isMobile) {
    return <AllNewsMobile news={publishedNews || []} />;
  }

  return <AllNewsDesktop />;
};

export default AllNewsFeature;
